const initialState = {};

const appointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_APPOINTMENT_DATA":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default appointmentReducer;
